/**
 * Recurring Gift Aid is the default for future generated donations.
 * Individual history rows can differ without changing that default.
 */
export type RecurringGiftAidOverview = {
  varies: boolean
  exceptionCount: number
}

export function summariseRecurringGiftAid(
  seriesGiftAidDeclared: boolean,
  occurrenceDeclared: readonly boolean[]
): RecurringGiftAidOverview {
  const exceptionCount = occurrenceDeclared.filter(
    (declared) => declared !== seriesGiftAidDeclared
  ).length

  return {
    varies: exceptionCount > 0,
    exceptionCount,
  }
}
